import React, { useState, useEffect } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import SubmitButton from 'components/SubmitButton';
import SimpleForm from 'components/SimpleForm';

import withAuthorization from 'components/Session/withAuthorization';
import { useFirebase } from 'components/Firebase/context';

import TextError from 'components/TextError';
import { messages } from '../../../src/messages';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500,
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

const PasswordChangeForm = (history, authUser) => {
  const classes = useStyles();
  const firebase = useFirebase();
  const [newpassword, setNewPassword] = useState({
    password: '',
    passwordConfirm: ''
  });
  const [error, setError] = useState(null);
  const [passwordMessage, setpasswordMessage] = useState(null);

  const onPasswordChanged = (name, value) => {
    setNewPassword({ ...newpassword, [name]: value });
  };
  const isCredsComplete = () => {
    const { password, passwordConfirm } = newpassword;
    return password.length > 0 && passwordConfirm.length > 0 && password === passwordConfirm;
  };
  async function handlePassword() {
    try {
      const error = !isCredsComplete();
      if (error) return setError('Password does not match');
      await firebase.doUserPasswordUpdate(newpassword.password);
      setNewPassword(
        {
          password: '',
          passwordConfirm: ''
        }
      );
      return setpasswordMessage(messages.passwordMessage);
    } catch (e) {
      if (e.message) return setError(e.message);
    }
  }

  return (
    <div >

      <Grid container spacing={2}>
        <Grid item xs={12} sm container>
          <SimpleForm
            title="Change Password"

            onSubmit={handlePassword}
          >
            {passwordMessage && <span>{passwordMessage}</span>}
            {error && <TextError>{error}</TextError>}
            <TextField
              label="Password"
              required
              fullWidth
              value={newpassword.password}
              type="password"
              onChange={e => onPasswordChanged('password', e.target.value)}
              autoComplete="new-password"
              margin="normal"
            />
            <TextField
              label="Re-enter Password"
              required
              fullWidth
              value={newpassword.passwordConfirm}
              type="password"
              onChange={e => onPasswordChanged('passwordConfirm', e.target.value)}
              autoComplete="new-password"
              margin="normal"
            />
            <SubmitButton>Submit</SubmitButton>
          </SimpleForm>
        </Grid>
      </Grid>

    </div>
  );
};

export default withAuthorization()(PasswordChangeForm);

